import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CommitteesStateService {
  private activeSectionSubject = new BehaviorSubject<string>('governing-body');
  activeSection$ = this.activeSectionSubject.asObservable();

  setActiveSection(id: string): void {
    this.activeSectionSubject.next(id);
  }
}
